import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // The local dev proxy also supports an HTTPS browser callback without mixed-content requests.
    if (typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname)
        && environment.apiGatewayUrl === 'http://localhost:4000'
        && req.url.startsWith(`${environment.apiGatewayUrl}/api/`)) {
      req = req.clone({ url: req.url.slice(environment.apiGatewayUrl.length) });
    }
    return next.handle(req.withCredentials && req.credentials === 'include'
      ? req
      : req.clone({ withCredentials: true, credentials: 'include' }));
  }
}
